/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  display: inline-block;
  width: 248px;
  height: 240px;
}
:host #parent {
  width: 100%;
  height: 100%;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  contain: paint;
  border-width: 1px;
  border-radius: 0.25rem;
  border-style: solid;
  border-color: #C5CACC;
  border-color: var(--davinci-color-outline-on-container, #C5CACC);
}
:host #parent #header {
  height: 2.5rem;
  font-size: 1.125rem;
  display: grid;
  grid-template-columns: auto -webkit-min-content;
  grid-template-columns: auto min-content;
  grid-template-rows: auto;
  border-bottom-width: 1px;
  border-color: #C5CACC;
  border-color: var(--davinci-color-outline-on-container, #C5CACC);
  border-bottom-style: solid;
  padding-top: 0.4rem;
  padding-bottom: 0.5rem;
}
:host #parent #header #title {
  padding-left: 1rem;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  color: var(--davinci-color-text-on-background, );
}
:host #parent #header #icon {
  padding-left: 1rem;
  padding-right: 0.75rem;
}
:host #parent #header #icon * {
  fill: var(--davinci-color-text-on-background, );
  width: 1.125rem;
  height: 1.125rem;
}
:host #symbol {
  height: 1%;
  flex: 1;
  padding-top: 1.3rem;
}
:host #symbol davinci-icon-ref {
  width: 100%;
  height: 100%;
}
:host #text {
  max-height: 135px;
  padding: 0.5rem 1rem 1rem;
  margin: 0 auto;
  max-height: 100%;
  max-width: 100%;
  font-size: 2rem;
}

:host([status=warning]) {
  background-color: var(--davinci-color-warning-light, );
  color: var(--davinci-color-warning, );
}
:host([status=warning]) #symbol > davinci-icon-ref {
  fill: var(--davinci-color-warning, );
}

:host([status=error]) {
  background-color: var(--davinci-color-error-light, );
  color: var(--davinci-color-error, );
}
:host([status=error]) #symbol > davinci-icon-ref {
  fill: var(--davinci-color-error, );
}

:host([status=ok]) {
  background-color: var(--davinci-color-success-light, );
  color: var(--davinci-color-success, );
}
:host([status=ok]) #symbol > davinci-icon-ref {
  fill: var(--davinci-color-success, );
}

:host([status=unknown]) {
  background-color: var(--davinci-color-unknown-light, );
}
:host([status=unknown]) #symbol > davinci-icon-ref {
  fill: var(--davinci-color-unknown, );
}

:host {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-container, #FFFFFF);
}
:host #symbol > davinci-icon-ref {
  fill: var(--davinci-color-text-on-background, );
}

:host([header-icon=settings]) #parent {
  border-color: #2C3133;
  border-color: var(--davinci-color-outline-on-container-edit, #2C3133);
}

:host([hidden]) {
  display: none;
}`;
export { style };
